import { GET_ALL_GUARDIANS, GET_GUARDIAN, GET_SCHOOL_GUARDIANS, GET_UNMAPPED_GUARDIANS } from 'actions/admin/guardians';

const initialState = {
  guardiansData: {
    content: [],
  },
  guardian: {},
  guardianList: [],
  unMappedGuardianList: [],
};

export default function guardians(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ALL_GUARDIANS:
      return { ...state, guardiansData: action.guardiansData };
    case GET_GUARDIAN:
      return { ...state, guardian: action.guardian };
    case GET_SCHOOL_GUARDIANS:
      return { ...state, guardianList: action.guardians };
    case GET_UNMAPPED_GUARDIANS:
      return { ...state, unMappedGuardianList: action.guardians };
    default:
      return state;
  }
}
